<div class="aum-action-bar" #actionbarwrapper>
    <button
        aum-icon-button
        [icon]="backButtonIcon"
        [routerLink]="backButtonRouterLink"
        color="warn"
        (click)="backButtonAction()"
        *ngIf="backButtonText"
    >
        <span class="aum-typo-paragraph" *ngIf="backButtonPrefixText !== null">{{ backButtonPrefixText }} </span>{{
        backButtonText }}
    </button>
    <ng-content></ng-content>
    <span class="aum-action-bar-spacer"></span>

    <button
        *ngIf="actionButtonText != null"
        aum-button
        [disabled]="actionButtonDisabled"
        color="basic"
        (click)="actionButtonAction()"
    >
        {{actionButtonText}}
    </button>

    <ng-container *ngIf="extraActionButtons">
        <button
            *ngFor="let extraActionButton of extraActionButtons"
            aum-button
            [disabled]="extraActionButton.disabled"
            color="primary"
            (click)="extraActionButton.action()"
            [ngClass]="extraActionButton.styleClassName"
        >
            <img [src]="extraActionButton.icon" *ngIf="extraActionButton.icon" alt="icon" />
            {{ extraActionButton.label }}
        </button>
    </ng-container>

    <button
        *ngIf="nextButtonText"
        aum-button
        [disabled]="nextButtonDisabled"
        color="primary"
        (click)="nextButtonAction()"
        [routerLink]="nextButtonRouterLink"
    >
        <span class="aum-typo-paragraph" *ngIf="nextButtonPrefixText !== null">{{nextButtonPrefixText}} </span
        >{{nextButtonText}}
    </button>
</div>
